import { render, staticRenderFns } from "./UserChats.vue?vue&type=template&id=044addb9&scoped=true"
import script from "./UserChats.vue?vue&type=script&lang=js"
export * from "./UserChats.vue?vue&type=script&lang=js"
import style0 from "./UserChats.vue?vue&type=style&index=0&id=044addb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044addb9",
  null
  
)

export default component.exports